import { Link } from 'react-router-dom';
import Arrow from '../../components/ui/Arrow';
import { localizedPath, useLocale, useMessages } from '../../i18n/locale';

export default function ContactPage() {
  const locale = useLocale();
  const messages = useMessages();
  const copy = messages.contactPage;
  return (
    <main className="module-page">
      <section className="module-hero module-hero--contact">
        <div className="module-hero__grid" aria-hidden="true" />
        <div className="container module-hero__inner">
          <div className="module-hero__copy">
            <div className="module-breadcrumb">
              <Link to={localizedPath(locale)}>{messages.modulePage.home}</Link>
              <span>/</span>
              <Link to={localizedPath(locale, '/company')}>{copy.about}</Link>
              <span>/</span>
              <span>{copy.name}</span>
            </div>
            <div className="module-eyebrow">
              <span className="module-eyebrow__dot" /> {copy.eyebrow}
            </div>
            <h1>
              <span>{copy.title[0]}</span>
              <span className="module-hero__muted">{copy.title[1]}</span>
            </h1>
            <p>{copy.description}</p>
            <div className="module-hero__actions">
              <Link className="button button--primary" to={localizedPath(locale, '/company')}>
                {copy.aboutUs} <Arrow up />
              </Link>
              <span className="module-draft-label">CONTACT / {messages.modulePage.comingSoon}</span>
            </div>
          </div>
          <div className="module-art" aria-hidden="true">
            <div className="module-art__ring module-art__ring--outer" />
            <div className="module-art__ring module-art__ring--inner" />
            <div className="module-art__core">
              <span>✳</span>
              <small>{copy.artLabel}</small>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
